export class LoginData {
  code: string;
  email?: string;
  password?: string;
  rememberMe?: string;
  constructor(code?: string) {
    this.code = code;
  }
}
